module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAASCAYAAACuLnWgAAAAmklEQVRIS+2TsQ3CMBRE301AQ5MFKMkEqZiNli3YIiVVpEjJEjQ0bHBREI4QspAiG1dx5cLf73y+EwWWAsN2D1wkXXNzXxDbI3Cc95I+wc4BDJAT0EYgT2CXClpUp170a36DrHK3nF2298Ajkq4zcFglO3I4RPgOVH/tybuQc/FukppU5d/z5f4kt/LtJUmOhgjXwBCJcJejJxN9fzGcntOt9gAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon-index-more.png
// module id = 916
// module chunks = 0